<div [formGroup]="form" class="revoke-dialog-container">
    <h2 mat-dialog-title>
        {{ data.action === 'suspend' ? 'Zertifikat suspendieren' : 'Zertifikat widerrufen' }}
    </h2>

    <mat-dialog-content>
        <p class="confirmation-text">
            Sind Sie wirklich sicher, dass Sie das Zertifikat <strong>“{{ data.certName }}”</strong>
            für <strong>“{{ data.holderName }}”</strong>
            vom <strong>“{{ data.issuanceDate | date:'dd.MM.yyyy' }}”</strong>
            {{ data.action === 'suspend' ? 'suspendieren' : 'widerrufen' }} wollen?
        </p>

        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Begründung</mat-label>
            <textarea matInput formControlName="reason" placeholder="Bitte geben Sie eine Begründung an..." rows="12"
                required></textarea>
            <mat-error *ngIf="form.get('reason').hasError('required')">
                Begründung ist erforderlich.
            </mat-error>
        </mat-form-field>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-stroked-button color="primary" (click)="onCancel()">Nein</button>
        <button mat-raised-button [color]="data.action === 'suspend' ? 'accent' : 'warn'"
            (click)="onConfirm()" [disabled]="form.invalid">Ja</button>
    </mat-dialog-actions>
</div>
